module.exports = "<div (click)=\"clickHandler()\" class=\"item-wrapper\" title=\"Exportar\">\n    <i [class]=\"itemIconClass\">\n        {{itemIconContent}}\n    </i>\n    <span>{{itemLabel}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/exportar/itemExportacao/item-exportacao.component.html
// module id = ./src/app/components/exportar/itemExportacao/item-exportacao.component.html
// module chunks = main